module.exports = __webpack_public_path__ + "img/img_judges2.5832ab07.png";